// «Мой профиль → Telegram» (план 155 Ф3): привязка к боту уведомлений
// сотрудников, «Прислать тестовое» и какие виды уведомлений дублировать.
import { api } from '@/lib/api';

export interface MyTelegramLink {
  username: string | null;
  linked_at: string;
  /** Человек остановил бота: сообщения не доходят. */
  blocked_at: string | null;
  last_sent_at: string | null;
  last_error: string | null;
  last_error_at: string | null;
}

export interface MyTelegramKind {
  kind: string;
  label: string;
  enabled: boolean;
  default_enabled: boolean;
}

export interface MyTelegram {
  /** Бот сотрудников настроен на сервере. */
  configured: boolean;
  bot_username: string | null;
  link: MyTelegramLink | null;
  kinds: MyTelegramKind[];
}

export function getMyTelegram(): Promise<MyTelegram> {
  return api.get<MyTelegram>('/me/telegram');
}

export function issueTelegramLink(): Promise<{ url: string; expires_at: string }> {
  return api.post<{ url: string; expires_at: string }>('/me/telegram/link-token');
}

export function unlinkMyTelegram(): Promise<void> {
  return api.delete<void>('/me/telegram');
}

export function sendTelegramTest(): Promise<{ ok: true }> {
  return api.post<{ ok: true }>('/me/telegram/test');
}

export function setTelegramKind(kind: string, enabled: boolean): Promise<MyTelegram> {
  return api.put<MyTelegram>('/me/telegram/prefs', { kind, enabled });
}
